// import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
// import { useFormikContext } from "formik";

// const containerStyle = {
//   width: "100%",
//   height: "300px"
// };

// const defaultCenter = {
//   lat: 12.9716,
//   lng: 77.5946
// };

// const MapPicker = () => {
//   const { values, setFieldValue } = useFormikContext();

//   const handleClick = (e) => {
//     if (e.latLng) {
//       const lat = e.latLng.lat();
//       const lng = e.latLng.lng();
//       setFieldValue("latitude", lat);
//       setFieldValue("longitude", lng);
//     }
//   };

//   return (
//     <LoadScript googleMapsApiKey={'AIzaSyDURu1GQkz8XhML9KTW8N_NRVQvIh4pIsU'}>
//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         center={
//           values.latitude && values.longitude
//             ? { lat: Number(values.latitude), lng: Number(values.longitude) }
//             : defaultCenter
//         }
//         zoom={13}
//         onClick={handleClick}
//       >
//         {values.latitude && values.longitude && (
//           <Marker position={{ lat: Number(values.latitude), lng: Number(values.longitude) }} />
//         )}
//       </GoogleMap>
//     </LoadScript>
//   );
// };

// export default MapPicker;


import { useRef } from "react";
import { useFormikContext } from "formik";
import { GoogleMap, Marker, StandaloneSearchBox, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = { width: "100%", height: "300px" };
const defaultCenter = { lat: 12.9716, lng: 77.5946 };

const MapPicker = () => {
  const { values, setFieldValue } = useFormikContext();
  const searchBoxRef = useRef(null);

  // Load Google Maps with Places library
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDURu1GQkz8XhML9KTW8N_NRVQvIh4pIsU",
    libraries: ["places"],
  });

  const handlePlacesChanged = () => {
    if (!searchBoxRef.current) return;

    const places = searchBoxRef.current.getPlaces();
    if (places?.length) {
      const place = places[0];
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const formattedAddress = place.formatted_address;

      setFieldValue("latitude", lat);
      setFieldValue("longitude", lng);
      setFieldValue("address", formattedAddress);
    }
  };

  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <>
      <StandaloneSearchBox
        onLoad={(ref) => (searchBoxRef.current = ref)}
        onPlacesChanged={handlePlacesChanged}
      >
        <input
          type="text"
          placeholder="Search Apartment or Address"
          style={{
            boxSizing: `border-box`,
            border: `1px solid #ccc`,
            width: `100%`,
            height: `40px`,
            padding: `0 12px`,
            borderRadius: `4px`,
            fontSize: `16px`,
            marginBottom: "8px",
          }}
        />
      </StandaloneSearchBox>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={
          values.latitude && values.longitude
            ? { lat: Number(values.latitude), lng: Number(values.longitude) }
            : defaultCenter
        }
        zoom={15}
      >
        {values.latitude && values.longitude && (
          <Marker position={{ lat: Number(values.latitude), lng: Number(values.longitude) }} />
        )}
      </GoogleMap>
    </>
  );
};

export default MapPicker;


